export const useRows = (data, columns) => {
  if (!data) return [];

  return Object.entries(data).map(([key, value]) => {
    const items = value.map((item) => {
      const [name, date, shift, type, count] = item;
      return { name, shift, date, type, count };
    });

    const footer = Array.isArray(columns)
      ? columns.map((col) => {
          if (col.field === 'count') {
            const total = items.reduce((sum, row) => {
              const val = +row.count;
              return Number.isNaN(val) ? sum : sum + val;
            }, 0);
            return (+total.toFixed(2)).toString();
          }
          return '';
        })
      : undefined;

    return { title: key, items, footer };
  });
};
